<template>
  <div class="pod-list-container" ref="listContainer">
    <swiper :options="swiperOption" ref="podroomListViewSwiper">
        <swiper-slide v-for="podRoom in joinedPodRoomList" :key="podRoom.id">
          <div class="pa-connections-item" :class="getPodClass(podRoom)" @click.prevent="handleClickPod(podRoom)">
            <div class="pa-title-wrap">
              <div class="pa-title">{{podRoom.name}}</div>
            </div>
            <div class="pa-content-box">
              <ul class="member-list">
                <li v-for="character in podRoom.characterList" :key="character.id">
                  <CharacterIcon :character="character" :clickable="false" />
                </li>
              </ul>
            </div>
          </div>
        </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {GetPodRoomList} from '@/graphql/queries/ConnectionPod.graphql'

import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'

export default {
  components : {
    CharacterIcon
  },

  props : {
    contentFieldHeight : {
      default: null
    }
  },

  data(){
    return {
      swiperOption: {
        direction     : 'vertical',
        slidesPerView : 3,
        loop          : false,
        speed         : 800,
        pagination    : false,
        touchStartStopPropagation : true,
        touchMoveStopPropagation  : true,
        touchStopStopPropagatio   : true,
        on            : {
          init : function(){
          },
          touchStart : function(event){
            event.stopPropagation();
          },
          touchEnd   : function(event){
            event.stopPropagation();
          }
        }
      }
    };
  },

  computed : {
    podRoomType(){
      // return this.$store.state.connection.podRoomType;
      return 'private';
    }
  },

  watch : {
    contentFieldHeight : {
      handler(value){
        if(typeof value === 'undefined') return;
        if(value === null) return;
        if(typeof this.$refs.listContainer === 'undefined') return;
        if(this.$refs.listContainer === null) return;

        this.$refs.listContainer.querySelector('.swiper-container').style.height = value+'px';
      },
      immediate: true
    }
  },

  apollo : {
    joinedPodRoomList : {
      query : GetPodRoomList,
      variables(){
        return {
          roomType  : this.podRoomType
        };
      }
    },
  },

  // watch : {
  //   joinedPodRoomList(data){
  //     console.log(data);
  //   }
  // },

  methods : {
    getPodClass(){
      return [];
    },

    handleClickPod(podRoom){
      this.$emit('selectPodRoom', podRoom);
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pod-list-container{
  width:98%;
  margin:0 auto;
  position: relative;

  .swiper-container{
    overflow: hidden;
    height:286px;
  }

  .pa-connections-item{
    position: relative;
    box-sizing: border-box;
    padding-top:1.2rem;

    .pa-title-wrap{
      width:100%;
      position: absolute;
      top:0.5rem;
      z-index: 1;
      
      .pa-title{
        font-family: 'mplus-1m-medium';
        font-weight: bold;
        text-align: center;
        font-size:1rem;
        line-height: 1.4rem;
        background-color: #89620C;
        color:#D2BA9E;
        letter-spacing: .1rem;
        border-radius: 12px;
        width:85%;
        margin:0 auto;
        user-select: none;

        @media screen and (min-width: $desktop) {
          font-size:1.3rem;
          line-height: 1.8rem;
        }
      }
    }

    .pa-content-box{
      padding-top:.8rem;
      border-radius: 8px;
      background-color:#CCAA8B;
      position: relative;
      background-image: url('~@/components/Parts/PAConnectionManageModal/Images/large_meltingpod.svg');
      background-repeat: no-repeat;
      background-position: 50% 1.7rem;
      background-size:110%;
      width: 100%;

      @media screen and (min-width: $desktop) {
        background-size:155%;
        background-position: 50% 0;
      }

      .member-list{
        padding:.3rem .1rem .2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width:98%;
        margin:0 auto;
        user-select: none;

        li{
          margin:0 !important;
          padding:0 !important;
          padding-bottom:.2rem !important;
          text-align: center;
          width:100%;

          img{
            width:2.7rem;
          }

          .pa-character-icon{
            background-color:#C4A27A;
            width:2.7rem;
            height:2.7rem;
            line-height: 2.6rem;
          }
        }

        @media screen and (min-width: $desktop) {
          li{
            padding-top:.5rem !important;
            img{
              width:3.5rem;
            }
          }
        }
      }
    }

    &-disabled{
      .pa-title-wrap{
        .pa-title{
          background-color: #A48541;
          color:#AE8E48;
        }
      }

      .pa-content-box{
        background-color:#C8AC8A;
        background-image: url('~@/components/Parts/PAConnectionManageModal/Images/large_meltingpod_disabled.svg');

        .member-list{
          li{
            .pa-character-icon{
              background-color: #C8A880;
              color:#AE8E48;
            }
          }
        } 
      }
    }
  }
}
</style>